"use client";

import { useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "@/app/lib/firebase";
import { initMixpanel, mixpanelIdentify, mixpanelReset } from "@/app/lib/mixpanel";

/** Initializes Mixpanel and identifies users when they log in. */
export function MixpanelProvider() {
  useEffect(() => {
    initMixpanel();
  }, []);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        mixpanelReset();
        return;
      }

      mixpanelIdentify(user.uid, {
        $email: user.email || undefined,
        $name: user.displayName || undefined,
      });

      try {
        const profileRef = doc(db, "profiles", user.uid);
        const profileSnap = await getDoc(profileRef);
        if (profileSnap.exists()) {
          const data = profileSnap.data();
          mixpanelIdentify(user.uid, {
            $email: user.email || data?.email || undefined,
            $name: user.displayName || data?.displayName || undefined,
            plan: data?.plan,
          });
        }
      } catch {
        // Non-blocking; we already set basic props above
      }
    });

    return () => unsub();
  }, []);

  return null;
}
